import React from 'react';

export default function InputRadioGroup({
	label,
	name,
	value,
	onChange,
	options = [],
	error,
	required,
}) {
	return (
		<div className="form-group">
			{label && (
				<label className="form-label">
					{label}
					{required && <span style={{ color: 'red', marginLeft: 2 }}>*</span>}
				</label>
			)}

			<div className="d-flex gap-4 mt-1">
				{options.map((opt) => (
					<label
						key={opt.value}
						className="payment-option"
					>
						<input
							type="radio"
							name={name}
							value={opt.value}
							checked={value === opt.value}
							onChange={(e) => onChange(e.target.value)}
						/>
						{opt.label}
					</label>
				))}
			</div>

			{error && <p style={{ color: 'red', fontSize: '12px', marginTop: 4 }}>{error}</p>}
		</div>
	);
}
